import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section className="py-20 bg-brand-gray" id="preise" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-95">
            Transparent. Fair. Ohne Überraschungen.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-96">
          {/* Testphase Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 border-2 border-brand-accent shadow-lg relative flex flex-col" data-id="element-97">
            <div className="absolute top-0 right-8 transform -translate-y-1/2" data-id="element-98">
              <span className="bg-brand-accent text-white text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-full" data-id="element-99">
                Aktionspreis anfragen!
              </span>
            </div>

            <div className="mb-8" data-id="element-100">
              <h3 className="text-3xl font-bold text-brand-dark mb-2" data-id="element-101">
                Testphase
              </h3>
              <p className="text-brand-accent font-medium" data-id="element-102">
                4 Wochen inkl. Einrichtung
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-103">
              {['Vollständige Einrichtung', '100 Gesprächsminuten inklusive', 'Zusammenfassung per E-Mail', 'Persönlicher Ansprechpartner'].map((item, i) => <li key={i} className="flex items-start" data-id="element-104">
                  <Check className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-105" />
                  <span className="text-gray-700" data-id="element-106">{item}</span>
                </li>)}
            </ul>

            <a href="mailto:dialog@voxspace.de?subject=Anfrage%20Test%20KI-Telefonassistent&body=Liebes%20vox%20space%20Team%2C%0A%0Aich%20m%C3%B6chte%20gerne%204%20Wochen%20testen.%0ARufen%20Sie%20mich%20zur%C3%BCck%20unter%3A%20%5BVorwahl%5D%20Rufnummer." className="block w-full py-4 px-6 text-center rounded-xl font-semibold text-brand-accent bg-brand-light hover:bg-blue-100 transition-colors" data-id="element-107">
              Jetzt Testphase starten
            </a>
          </motion.div>

          {/* Quartalspaket Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-brand-accent rounded-3xl p-8 shadow-xl relative flex flex-col text-white" data-id="element-108">
            <div className="absolute top-0 right-8 transform -translate-y-1/2" data-id="element-109">
              <span className="bg-brand-dark text-white text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-full" data-id="element-110">
                Empfohlen
              </span>
            </div>

            <div className="mb-8" data-id="element-111">
              <h3 className="text-3xl font-bold mb-2" data-id="element-112">Quartalspaket</h3>
              <p className="text-blue-100 font-medium" data-id="element-113">3 Monate Laufzeit</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-114">
              {['500 Gesprächsminuten inklusive', 'E-Mail und Live Dashboard inklusive', 'Zusatzminuten ab 0,18 €/Min.', 'automatische Verlängerung'].map((item, i) => <li key={i} className="flex items-start" data-id="element-115">
                  <Check className="w-5 h-5 text-white mr-3 flex-shrink-0 mt-0.5" data-id="element-116" />
                  <span className="text-blue-50" data-id="element-117">{item}</span>
                </li>)}
            </ul>

            <a href="tel:+4941811352424" className="block w-full py-4 px-6 text-center rounded-xl font-semibold text-brand-accent bg-white hover:bg-blue-50 transition-colors shadow-lg" data-id="element-118">
              Lassen Sie uns sprechen
            </a>
          </motion.div>

          {/* Monatspaket Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-brand-dark rounded-3xl p-8 shadow-xl relative flex flex-col text-white" data-id="element-119">
            <div className="mb-8" data-id="element-120">
              <h3 className="text-3xl font-bold mb-2" data-id="element-121">Monatspaket</h3>
              <p className="text-blue-300 font-medium" data-id="element-122">Monatlich kündbar</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-123">
              {['100 Gesprächsminuten inklusive', 'Zusammenfassung per E-Mail', 'Zusatzminuten ab 0,25 €/Min.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-124">
                  <Check className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-125" />
                  <span className="text-gray-200" data-id="element-126">{item}</span>
                </li>)}
            </ul>

            <a href="tel:+4941811352424" className="block w-full py-4 px-6 text-center rounded-xl font-semibold text-white bg-brand-accent hover:bg-blue-600 transition-colors shadow-lg hover:shadow-blue-500/30" data-id="element-127">
              Lassen Sie uns sprechen
            </a>
          </motion.div>
        </div>

        <div className="text-center mt-8" data-id="element-128">
          <p className="text-sm text-gray-500" data-id="element-129">
            Alle Preise zzgl. gesetzlicher MwSt.
          </p>
        </div>
      </div>
    </section>;
}